import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { AppProviders } from './app/AppProviders';
import { router } from './app/router';
import { capturePendingAuthFlow } from './lib/authFlow';
import './styles/tokens.css';
import './styles/index.css';

// MUST run before the Supabase client is ever constructed: `detectSessionInUrl` consumes and
// CLEARS window.location.hash on construction, taking the `type=invite` marker with it. The
// client is created lazily from React effects, so this statement always wins the race.
capturePendingAuthFlow();

const rootEl = document.getElementById('root');
if (rootEl === null) {
  throw new Error('Root element #root not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
